
import React, { useEffect, useState } from "react";
import { Spin } from "antd";
import { FaHeart, FaRegHeart, FaShareAlt } from "react-icons/fa";
import Service from "services/service";
import { globalStore } from "stores/globalStore";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "./Category.css";

const Category = () => {
  const { landingPageData, setLandingPageData, category, setCategory } = globalStore();
  const [loading, setLoading] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [products, setProducts] = useState([]);
  const [wishlist, setWishlist] = useState([]);
  const [shareDropdown, setShareDropdown] = useState(null);

  const navigate = useNavigate();

  const fetchWishlist = async () => {
    try {
      const res = await Service.getWishlistService();
      const ids = (res.data || []).map((item) => item.productId?._id || item.productId);
      setWishlist(ids);
    } catch {}
  };

  const toggleWishlist = async (e, productId) => {
    e.stopPropagation();
    const token = localStorage.getItem("authToken");
    if (!token) {
      toast.info("Please login to add to wishlist");
      navigate("/login");
      return;
    }
    try {
      if (wishlist.includes(productId)) {
        await Service.removeWishlistService({ productId });
        setWishlist((prev) => prev.filter((id) => id !== productId));
        toast.success("Removed from wishlist");
      } else {
        //  const payload = { items: productId };
        const payload = { items: [{"product":productId}] };
        const res = await Service.addOrUpdateWishlistService(payload);
        // await Service.addOrUpdateWishlistService({ productId });
        setWishlist((prev) => [...prev, productId]);
        toast.success("Added to wishlist");
      }
    } catch {
      toast.error("Something went wrong");
    }
  };

  const getProductByCategory = async (categoryName) => {
    if (!categoryName) return;
    
    setLoading(true);
    try {
      const response = await Service.getProductByCategory(categoryName);
      const productData = response.data.data;
      console.log("Products for category", categoryName, ":", productData);
      setProducts(productData || []);
      setLandingPageData({
        ...landingPageData,
        productByCategory: productData,
      });
    } catch (error) {
      console.error("Error fetching category products:", error);
      setProducts([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchCategories = async () => {
    try {
      const response = await Service.getAllCategory();
      const categories = response.data.data;
      console.log("Categories fetched:", categories);
      setCategory(categories);
      if (categories && categories.length > 0) {
        const firstCategory = categories[0].name;
        setSelectedCategory(firstCategory);
        await getProductByCategory(firstCategory);
      }
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  useEffect(() => {
    fetchCategories();
    fetchWishlist();
  }, []);

  useEffect(() => {
    if (!shareDropdown) return;
    const close = () => setShareDropdown(null);
    document.addEventListener("click", close);
    return () => document.removeEventListener("click", close);
  }, [shareDropdown]);

  const handleCategoryClick = async (categoryName) => {
    setSelectedCategory(categoryName);
    await getProductByCategory(categoryName);
  };

  const handleClick = (productId) => {
    navigate(`/product/${productId}`);
  };

  const shareProduct = async (e, product) => {
    e.stopPropagation();
    const url = `${window.location.origin}/product/${product._id}`;
    const text = `Check out ${product.name}! ₹${product.discountPrice?.toFixed(1)} (${product.discount}% OFF)`;

    if (navigator.share) {
      try {
        await navigator.share({ title: product.name, text, url });
      } catch {}
    } else {
      setShareDropdown((prev) => (prev === product._id ? null : product._id));
    }
  };

  const getShareLinks = (product) => {
    const url = encodeURIComponent(`${window.location.origin}/product/${product._id}`);
    const text = encodeURIComponent(`Check out ${product.name}! ₹${product.discountPrice?.toFixed(1)} (${product.discount}% OFF)`);
    return [
      { name: "WhatsApp", icon: "🟢", href: `https://wa.me/?text=${text}%20${url}` },
      { name: "Facebook", icon: "🔵", href: `https://www.facebook.com/sharer/sharer.php?u=${url}` },
      { name: "Messenger", icon: "🟣", href: `https://www.facebook.com/dialog/send?link=${url}&app_id=291494419107518&redirect_uri=${url}` },
      { name: "Gmail", icon: "📧", href: `mailto:?subject=${encodeURIComponent(product.name)}&body=${text}%20${url}` },
      { name: "SMS", icon: "💬", href: `sms:?body=${text}%20${url}` },
      { name: "X", icon: "⬛", href: `https://twitter.com/intent/tweet?text=${text}&url=${url}` },
    ];
  };

  return (
    <div className="columnpolo">
      {/* Category Buttons - Centered on desktop, scrollable on mobile */}
      <div className="rowpolo_tshirts">
        {category && category.length > 0 ? (
          category.map((cat) => (
            <button
              key={cat._id}
              onClick={() => handleCategoryClick(cat.name)}
              className={`polo_tshirts ui button gray_900 ${
                selectedCategory === cat.name ? "fill tshirts" : "outline"
              }`}
            >
              {cat.name}
            </button>
          ))
        ) : (
          <div className="no-categories">Loading categories...</div>
        )}
      </div>

      {/* Product List */}
      <div className="listmenstopman">
        {loading ? (
          <div className="loader">
            <Spin size="large" />
          </div>
        ) : products && products.length > 0 ? (
          products.map((product) => (
            <div
              onClick={() => handleClick(product._id)}
              style={{ cursor: "pointer" }}
              key={product._id}
              className="column-6"
            >
              <div className="product-image-wrapper">
                <img
                  src={product.primaryImage}
                  alt={product.name}
                  className="Bottom_Category_image"
                  onError={(e) => {
                    e.target.src = 'https://via.placeholder.com/300x300?text=No+Image';
                  }}
                />
                <button
                  className="wishlist-heart-btn"
                  onClick={(e) => toggleWishlist(e, product._id)}
                  aria-label="Toggle wishlist"
                >
                  {wishlist.includes(product._id) ? (
                    <FaHeart className="heart-icon filled" />
                  ) : (
                    <FaRegHeart className="heart-icon" />
                  )}
                </button>
                <div className="share-btn-wrapper">
                  <button
                    className="share-btn"
                    onClick={(e) => shareProduct(e, product)}
                    aria-label="Share product"
                  >
                    <FaShareAlt className="share-icon" />
                  </button>
                  {shareDropdown === product._id && (
                    <div className="share-dropdown" onClick={(e) => e.stopPropagation()}>
                      {getShareLinks(product).map((s) => (
                        <a key={s.name} href={s.href} target="_blank" rel="noopener noreferrer" className="share-option">
                          <span>{s.icon}</span> {s.name}
                        </a>
                      ))}
                    </div>
                  )}
                </div>
              </div>

              <div className="columnprice">
                <div className="columnenterotp">
                  <h2 className="menstopman ui heading size-headingmd">
                    {product.name}
                  </h2>
                  <p className="michaelkors ui text size-textmd">
                    {product.category}
                  </p>
                </div>
                <div className="rowprice-4">
                  <strong>₹{product.discountPrice?.toFixed(1)}</strong>
                  <strike>₹{product.price?.toFixed(1)}</strike>
                  <p className="offer-3 ui text size-textmd">
                    ({product.discount}% OFF)
                  </p>
                </div>
              </div>
            </div>
          ))
        ) : (
          !loading && (
            <div className="no-products-found">
              <div className="empty-state-card">
                <div className="empty-icon">📦</div>
                <h2>No products found</h2>
                <p>Try selecting a different category</p>
              </div>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default Category;